import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import FuseDatePicker from "./FuseDatePicker";
import FuseCheckBox from "./FuseCheckBox";
import moment from "moment";
import FuseSelectInput from "./FuseSelectInput";
import { Form } from "react-bootstrap";
import _ from "lodash";

function FuseNumberInput(props) {
  const inputComponent = useRef(null);

  const [isValidValue, setIsValidValue] = useState(false);

  const textBoxType = "input";
  const textBoxInputType = "number";

  useEffect(() => {
    updateValidity();
  });

  const getErrorDescription = (err) => {
    // console.log(err);
    if (err === "ValueMissing") return `This field is required and cannot be empty`;
    if (err === "TooShort") return `This field has a minimum length of ${props.minLength} characters`;
    if (err === "TooLong") return `This field has a maximum length of ${props.maxLength} characters`;
    if (err === "PatternMismatch") {
      return `This field does not match the requested format`;
    }
    if (err === "BadInput") return `This field value is not a number`;
    return `This field value is not valid`;
  };

  const _invalidErrorMessage = () => {
    let errors = getValidateErrors();
    if (errors.length > 0) return getErrorDescription(errors[0]);
    else return "";
  };

  const checkValid = () => getValidateErrors().length === 0;
  const getValidateErrors = () => {
    let errors = [];
    if (inputComponent?.current != null) {
      const { validity } = inputComponent.current;
      if (validity?.badInput === true) errors.push("BadInput");
      if (validity?.valueMissing === true) errors.push("ValueMissing");
      if (validity?.tooShort === true) errors.push("TooShort");
      if (validity?.tooLong === true) errors.push("TooLong");
      if (validity?.patternMismatch == true) errors.push("PatternMismatch");
      if (validity?.rangeOverflow === true) errors.push("RangeOverflow");
      if (validity?.rangeUnderflow === true) errors.push("RangeUnderflow");
      if (validity?.stepMismatch === true) errors.push("StepMismatch");
      if (validity?.typeMismatch === true) errors.push("TypeMismatch");
      // console.log(props.id, validity, errors);
    } // else if (props?.id) console.log("current == null ", props.id);
    return errors;
  };

  const updateValidity = () => {
    if (!inputComponent?.current) return;
    setIsValidValue(checkValid());
    inputComponent.current.setCustomValidity(_invalidErrorMessage());
  };

  const handleChange = (e) => {
    props.onChange?.(e?.currentTarget?.value || "");
  };

  if (props.editable) {
    return (
      <Form.Control
        //type
        as={textBoxType}
        type={textBoxInputType}
        ref={inputComponent}
        step={(props.type === "double" || props.type === "Double") ? "0.01" : "any"}
        
        //identifiers
        key={props?.id}
        id={props?.id}
        //values
        value={props?.value || ""}
        placeholder={props.placeholder}
        //validation
        disabled={props.disabled || false}
        isInvalid={!isValidValue}
        required={props.required}
        // step={}
        max={props.maxValue}
        min={props.minValue}
        //handlers
        onChange={handleChange}
      />
    );
  } else {
    return <div key={props?.id}>{props?.value || ""}</div>;
  }
}

FuseNumberInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  numericPrecision: PropTypes.number,
  numericScale: PropTypes.number
};

export default FuseNumberInput;
